<template>
    <div class="billing-settings">
        <div class="section-billing section-billing-subscription">
            <div class="cards">
                <div class="card card-plan">
                    <header>
                        <i class="fa-solid fa-star"></i>
                        {{ $t('dash.settings.billing.card.current_plan.title') }}
                    </header>
                    <div class="content">
                        <div class="container-plan-info">
                            <div class="plan-info">
                                <div class="name-plan">
                                    {{ $t('dash.plan.subscription') }} {{ !infoUser._premium || !infoUser._premium.plan ? $t('dash.plan.free') : $t('dash.plan.'+Object.keys(plans)[infoUser._premium.plan]) }}
                                    <div v-if="infoUser._premium && infoUser._premium.active" class="badge-outline-r"><i class="fa-solid fa-circle"></i>{{ $t('dash.settings.billing.card.current_plan.active') }}</div>
                                </div>
                                <p>{{ $t("dash.plan.fonctionnalitys.summary").replace('%', getMaxPages).replace('%',getMaxUsers) }} <span class="more"> <router-link to="/dash/plan">{{ $t('dash.view_more') }}</router-link></span></p>
                            </div>
                            <div class="price">
                                {{getPricePlan(infoUser)}}€<span class="frequency"> / {{ infoUser._premium.is_annual ? $t('dash.plan.year') : $t('dash.plan.month') }}</span>
                            </div>
                        </div>

                        <div class="container-user">
                            <div class="listUser">
                                <div class="image" v-for="page in allPages.slice(0,5)" :key="page.id">
                                    <img :src="page.avatar ? page.avatar : 'img/avatar.jpg'">
                                </div>
                                <div class="ect" v-if="allPages.length > 5">
                                    <i class="fa-regular fa-ellipsis"></i>
                                </div>

                                <div class="plus">
                                    <router-link to="/dash/pages">
                                        <i class="fa-solid fa-plus"></i>
                                    </router-link>
                                </div>
                            </div>
                            <p>{{ allPages.length }}  {{ $t('dash.settings.billing.card.current_plan.amount_page').replace('%',getMaxPages) }}</p>
                        </div>

                        <div class="container-button-plan">
                            <router-link to="/dash/plan">
                                <div class="btn-outline-primary">{{ $t('dash.plan.upgrade') }}<i class="fa-regular fa-rocket"></i></div>
                            </router-link>
                        </div>
                    </div>

                </div>
                <div class="card card-billing-information">
                    <header>
                        <i class="fa-solid fa-bag-shopping"></i>
                        {{ $t('dash.settings.billing.card.billing_information.title') }}
                    </header>
                    <div class="content">
                        <div class="method">
                            <h5>{{ $t('dash.settings.billing.card.billing_information.method.title') }}</h5>
                            <div class="method-content">
                                <div class="card-icon" v-if="countryPaypal">
                                    <i class="fa-brands fa-cc-paypal"></i>
                                </div>
                                <div class="card-icon" v-else-if="last4 && !expMonth && !expYear">
                                    <i class="fa-solid fa-building-columns"></i>
                                </div>
                                <div class="card-icon" v-else>
                                    <i class="fa-brands fa-cc-visa"></i>
                                </div>
                                <div class="info-card">
                                    <template v-if="countryPaypal">
                                        <p>Paypal {{ $t('dash.settings.billing.card.billing_information.method.payer_paypal') }} {{ payer_email }} ({{ countryPaypal }} - {{ payer_id }})</p>
                                    </template>
                                    <template v-else-if="last4 && !expMonth && !expYear">
                                        <p>SEPA {{ $t('dash.settings.billing.card.billing_information.method.first_number_card') }} {{ last4 }}</p>
                                    </template>
                                    <template v-else-if="last4 && expMonth && expYear">
                                        <p>Visa {{ $t('dash.settings.billing.card.billing_information.method.first_number_card') }} {{ last4 }}</p>
                                        <p class="expire">{{ $t('dash.settings.billing.card.billing_information.method.expire_card') }} {{ expMonth }}/{{ expYear }}</p>
                                    </template>                                    
                                    <template v-else>
                                        <p>{{ $t('dash.settings.billing.card.billing_information.method.not_exist.title') }}</p>
                                        <p class="expire">{{ $t('dash.settings.billing.card.billing_information.method.not_exist.subtitle') }}</p>
                                    </template>
                                </div>
                            
                                <!-- <div v-if="last4 && (!infoUser._premium.active || infoUser._premium.plan == 0)" class="btn-primary" @click.stop="deletePaymentMethod">{{ $t('dash.button.delete')}}</div> -->
                                <!-- <div v-else class="btn-primary" @click.stop="openPopUp('paymentMethod')">{{ last4 || countryPaypal ? $t('dash.button.modify') : $t('dash.button.add')}}</div> -->
                                <div class="btn-primary" @click.stop="openPopUp('paymentMethod')">{{ last4 || countryPaypal ? $t('dash.button.modify') : $t('dash.button.add')}}</div>
                            </div>
                        </div>
                        <div class="information">
                            <h5>{{ $t('dash.settings.billing.card.billing_information.billing_information.title') }}</h5>
                            <div class="information-content">
                                <div class="info-billing">
                                    <p><i class="fa-solid fa-location-dot"></i>{{ getTextLocalisation }}</p>
                                
                                    
                                    <p><i class="fa-solid fa-briefcase"></i>{{ this.infoAccount.company &&  this.infoAccount.company !== '' ? this.infoAccount.company : 'Non definie'}}</p>
                                </div>
                                <div class="btn-primary" @click.stop="openPopUp('billingInformation')">{{ $t('dash.button.modify') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-billing section-billing-invoice">
            <div class="title-section">
                <div class="left">
                    <h2>{{ $t('dash.settings.billing.invoices.title') }}</h2>
                    <p>{{ $t('dash.settings.billing.invoices.subtitle') }}</p>
                </div>
                <div class="right">
                    <template v-if="invoices.length > 0">
                        <div class="btn-primary icon-l" v-if="invoiceSelect.length >= 1" @click="downloadInvoicesSelected">
                            <i class="fa-solid fa-download"></i>
                           {{ $t('dash.settings.billing.invoices.download_selection') }}
                        </div>

                        <div class="btn-primary icon-l" v-else @click="downloadAllInvoices">
                            <i class="fa-solid fa-download"></i>
                            {{ $t('dash.settings.billing.invoices.download_all') }}
                        </div>
                    </template>
                </div>
               
            </div>
            <div class="container-list-invoice" v-if="invoices.length > 0">
                <div class="legend">
                    <div>
                        <Checkbox :id="'selectAllInvoice'" :isChecked="invoiceSelect.length >= 1" :isLine="invoiceSelect.length < invoices.length  && invoiceSelect.length >= 1" :isDisable="invoices.length == 0" :add="addAllInvoice" :remove="removeAllInvoice"></Checkbox>
                        <p>{{ $t('dash.settings.billing.invoices.legend.invoices') }}</p>
                    </div>
                    <p class="legend-date">{{ $t('dash.settings.billing.invoices.legend.date') }}</p>
                    <p class="legend-amount">{{ $t('dash.settings.billing.invoices.legend.amount') }}</p>
                    <p class="legend-plan">{{ $t('dash.plan.subscription') }}</p>
              
                </div>

                <div class="invoice" v-for="invoice in invoices" :key="invoice.number">
                    <div class="invoice-name">
                        <Checkbox :id="invoice.number" :isChecked="invoiceSelect.includes(invoice.number)" :add="addSelectInvoice" :remove="removeSelectInvoice"></Checkbox>
                        <div class="svg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 36 44" fill="none">
                                <path d="M4.31826 0H25.0017C25.2296 0.0296647 25.4589 0.0524506 25.6853 0.0904987C26.6275 0.249355 27.4586 0.654342 28.1394 1.31148C30.3569 3.45192 32.5639 5.60247 34.7602 7.76311C35.2913 8.28289 35.6901 8.88994 35.8815 9.61694C35.9883 10.0221 36.0002 10.4353 36 10.8519C35.9978 20.3622 35.996 29.8725 35.9946 39.3828C35.9974 39.7155 35.966 40.0475 35.9007 40.3738C35.6321 41.6494 34.9343 42.6408 33.8246 43.3332C33.1277 43.773 32.3182 44.0044 31.4927 43.9996C22.4808 43.9967 13.4688 43.9967 4.45688 43.9996C3.95217 43.9991 3.45185 43.9064 2.98092 43.7259C1.15872 43.0374 0 41.3676 0 39.4293C0 27.8178 0.00115338 16.2056 0.00346015 4.59286C0.00461999 4.29972 0.0317573 4.00724 0.0845573 3.71883C0.424084 1.84136 1.95498 0.357481 3.8399 0.0659931C3.99885 0.0414875 4.15866 0.0214961 4.31826 0ZM34.508 25.0961C34.508 20.3765 34.508 15.657 34.508 10.9374C34.508 10.7655 34.5067 10.5935 34.492 10.4226C34.4659 10.1189 34.4224 9.81836 34.2641 9.54751C34.102 9.26419 33.9023 9.00389 33.6702 8.77365C31.7438 6.89417 29.8174 5.01576 27.8911 3.13844C27.6007 2.85512 27.3187 2.56169 27.0123 2.29643C26.3395 1.71432 25.5344 1.48861 24.657 1.48861C17.9789 1.4876 11.3008 1.4876 4.62254 1.48861C3.77913 1.48861 3.03822 1.75645 2.42859 2.34222C1.77332 2.97034 1.49024 3.75215 1.49046 4.65069C1.4919 16.2241 1.49269 27.7974 1.49284 39.3706C1.49123 39.5459 1.50243 39.7212 1.52636 39.8949C1.67774 40.9205 2.21363 41.6847 3.12927 42.1795C3.61088 42.4398 4.13293 42.5303 4.67941 42.5301C13.5296 42.5275 22.3799 42.5269 31.2302 42.5282C31.331 42.5282 31.432 42.5282 31.533 42.5252C32.4668 42.4886 33.2371 42.1167 33.8283 41.3966C34.3078 40.813 34.5082 40.132 34.508 39.3837C34.5062 34.621 34.5058 29.8585 34.5069 25.0961H34.508Z" fill="#121826"/>
                                <path d="M18.7277 11.049C18.7127 12.0105 18.5568 12.9146 18.3295 13.808C18.1805 14.3934 18.0268 14.9774 17.8719 15.5615C17.8626 15.5933 17.8602 15.6268 17.8648 15.6597C17.8694 15.6926 17.8809 15.7242 17.8985 15.7523C18.5004 16.8231 19.2651 17.7777 20.0347 18.7291C20.222 18.9606 20.4106 19.1913 20.597 19.4243C20.6349 19.4718 20.6703 19.486 20.7337 19.4778C21.3721 19.3955 22.0096 19.3059 22.6504 19.2414C23.497 19.1554 24.3463 19.1238 25.1938 19.2358C25.681 19.3003 26.1572 19.4078 26.588 19.6584C27.0839 19.946 27.3733 20.3596 27.3824 20.9467C27.3882 21.3336 27.2269 21.6311 26.9137 21.8495C26.6079 22.0645 26.2574 22.1539 25.8921 22.1909C24.919 22.2893 23.9962 22.0722 23.1024 21.7117C22.1762 21.337 21.3292 20.7923 20.6059 20.106C20.5282 20.0327 20.4619 20.0157 20.3587 20.0374C19.299 20.2594 18.2394 20.4757 17.2052 20.7958C16.6429 20.9699 16.0841 21.1584 15.5253 21.3448C15.4767 21.3648 15.4355 21.3994 15.4074 21.4437C14.9927 22.067 14.5908 22.7003 14.1657 23.317C13.5677 24.1842 12.9114 25.0045 12.1075 25.6969C11.5965 26.1369 11.0167 26.4374 10.3427 26.5419C10.0506 26.5908 9.75106 26.5724 9.46724 26.4882C9.00423 26.3476 8.56284 25.8407 8.62383 25.2878C8.6554 25.0017 8.78062 24.7549 8.94649 24.5256C9.25098 24.1045 9.645 23.7758 10.0622 23.4723C10.8269 22.9172 11.6649 22.4882 12.5109 22.0731C12.9849 21.8405 13.4589 21.6077 13.9304 21.3699C13.9862 21.3409 14.0315 21.2954 14.0601 21.2397C15.0296 19.1898 15.9146 17.1017 16.6948 14.9705C16.7168 14.9012 16.7168 14.8268 16.6948 14.7575C16.4909 14.1176 16.2517 13.4871 16.0787 12.8392C15.8438 11.9554 15.7439 11.0415 15.7822 10.1281C15.7899 9.88861 15.8224 9.65054 15.8791 9.41765C16.0804 8.62229 16.8538 8.26589 17.6031 8.61198C18.1319 8.85617 18.4217 9.29211 18.5776 9.83167C18.6959 10.2412 18.7186 10.6621 18.7277 11.049ZM17.5832 16.1831C17.0742 17.748 16.444 19.2399 15.7855 20.7403C17.2128 20.239 18.6688 19.8751 20.1881 19.6036C19.2251 18.5157 18.3509 17.4041 17.5832 16.1831ZM21.0079 19.8914C21.0451 19.9213 21.0609 19.9344 21.0775 19.9473C22.0291 20.652 23.1 21.1161 24.2237 21.4701C24.5161 21.5623 24.8138 21.6296 25.124 21.6165C25.5712 21.5978 25.9483 21.2994 26.0348 20.8964C26.1183 20.5094 25.9124 20.1057 25.5067 19.9136C25.31 19.8186 25.1024 19.7477 24.8885 19.7023C24.3595 19.5948 23.8193 19.6019 23.2853 19.6378C22.6292 19.6818 21.9763 19.7704 21.3221 19.8413C21.2242 19.8517 21.1281 19.8721 21.0079 19.8914ZM13.4959 22.1195L13.4758 22.1008C13.3158 22.181 13.1553 22.2605 12.9955 22.3409C12.223 22.7304 11.4374 23.0959 10.7051 23.56C10.2306 23.8609 9.77281 24.1833 9.39847 24.6068C9.2553 24.7691 9.1316 24.9445 9.06802 25.1545C8.91664 25.6556 9.34484 26.1126 9.85521 25.983C10.3076 25.8682 10.691 25.6225 11.0254 25.3035C11.8165 24.5486 12.4719 23.684 13.0749 22.7777C13.2191 22.561 13.3558 22.3394 13.4959 22.1195ZM16.9487 14.1055C16.9658 14.0937 16.9747 14.0911 16.9768 14.0858C16.9846 14.066 16.9905 14.0451 16.9967 14.0247C17.3354 12.9297 17.6059 11.8192 17.7091 10.6756C17.7372 10.3646 17.7193 10.0466 17.6918 9.73429C17.679 9.58768 17.6289 9.41787 17.5356 9.30931C17.1784 8.89293 16.7095 8.90991 16.4375 9.41679C16.4241 9.44216 16.4105 9.46731 16.399 9.49353C16.2861 9.74912 16.2374 10.0189 16.2232 10.2956C16.1951 10.8315 16.2772 11.3583 16.3529 11.8863C16.4611 12.6483 16.7102 13.3706 16.9487 14.1055Z" fill="#121826"/>
                                <path d="M15.7803 37.7018V30.9759C15.8058 30.9716 15.8316 30.9687 15.8575 30.9673C16.4732 30.972 17.0902 30.9608 17.7041 30.9871C18.3109 31.0131 18.8829 31.17 19.365 31.5657C19.794 31.9176 20.057 32.3776 20.2106 32.8985C20.536 34.0053 20.4904 35.1014 20.0239 36.1595C19.7229 36.8422 19.2253 37.3437 18.4846 37.5653C18.1697 37.6562 17.8435 37.7026 17.5155 37.7029C16.961 37.7087 16.4063 37.7052 15.8519 37.7057C15.8304 37.7061 15.8099 37.7042 15.7803 37.7018ZM16.9014 36.8043C17.1438 36.8043 17.3752 36.8196 17.6038 36.8013C18.1745 36.7555 18.6156 36.4963 18.8812 35.9782C18.9428 35.8612 18.995 35.7395 19.0374 35.6143C19.28 34.8675 19.2785 34.1096 19.1297 33.3465C19.0583 32.981 18.9197 32.6397 18.6608 32.3605C18.1771 31.8381 17.5447 31.8398 16.9014 31.8682V36.8043Z" fill="#121826"/>
                                <path d="M11.8611 35.0744V37.701H10.7495C10.7478 37.6638 10.7446 37.6264 10.7446 37.5888C10.7446 35.4228 10.7438 33.2569 10.7422 31.0909C10.7422 30.9923 10.7686 30.9643 10.8683 30.9656C11.5343 30.9749 12.2009 30.9656 12.8663 30.9888C13.15 31.0017 13.4314 31.0458 13.7054 31.1204C14.1967 31.2494 14.5137 31.5976 14.7088 32.0432C15.0021 32.713 14.9986 33.3975 14.6902 34.0613C14.4179 34.6477 13.9257 34.9544 13.2906 35.0163C12.8652 35.0578 12.4357 35.0568 12.0082 35.0742C11.9625 35.0759 11.9169 35.0744 11.8611 35.0744ZM11.8695 34.184C12.291 34.1769 12.7086 34.2186 13.1154 34.0948C13.3349 34.0282 13.5153 33.9044 13.605 33.6896C13.7914 33.2442 13.8038 32.7906 13.6007 32.3485C13.4861 32.0991 13.3014 31.8953 13.0069 31.8728C12.6349 31.8444 12.2608 31.8467 11.8875 31.8364C11.8819 31.8364 11.876 31.8442 11.8695 31.8489V34.184Z" fill="#121826"/>
                                <path d="M24.7185 33.8796V34.761H22.6149V37.6978H21.501V30.9727C21.5421 30.971 21.5771 30.968 21.6124 30.968C22.7862 30.968 23.9601 30.9673 25.1341 30.9658C25.2263 30.9658 25.2598 30.9852 25.2572 31.0836C25.25 31.3371 25.2548 31.5909 25.2548 31.8575H22.6164C22.6138 31.9026 22.6102 31.9366 22.6102 31.9708C22.6102 32.5686 22.6121 33.1664 22.6078 33.7642C22.6078 33.8609 22.6368 33.8833 22.7302 33.8826C23.3459 33.8785 23.9616 33.8807 24.5775 33.8807L24.7185 33.8796Z" fill="#121826"/>
                            </svg>
                        </div>
                        <p>{{ $t('dash.settings.billing.invoices.legend.invoice') }} #{{ invoice.number }}</p>
                    </div>
                    <p class="color-grey invoice-date">{{ invoice.date }}</p>
                    <p class="color-grey invoice-amount">EUR {{ invoice.amount }}€</p>
                    <p class="color-grey invoice-plan">{{ invoice.plan }}</p>
                  
                    <div class="btn-outline-primary icon-l" @click="downloadInvoice(invoice.pdf)">
                        <i class="fa-solid fa-download"></i>
                        <span>{{ $t('dash.button.download') }}</span>
                    </div>
                    <ContextMenu :options="[{label : $t('dash.settings.billing.invoices.copy_link'), name : 'copyLink'}]" :id="invoice.number" v-on:clickOption="clickOptionContextMenu">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </ContextMenu>
                </div>
            </div>
        </div>

        <PaymentMethodPopup :popupOpen="popupOpen" :closePopUp="closePopUp"></PaymentMethodPopup>
        <BillingInformationPopup :popupOpen="popupOpen" :closePopUp="closePopUp"  :infoAccount="infoAccount" :updateInfoAccount="updateInfoAccount"></BillingInformationPopup>
    </div>
</template>

<script>

import Checkbox from '../utils/checkbox.vue';
import PaymentMethodPopup from './payment-method-popup.vue';
import BillingInformationPopup from './billing-information-popup.vue'
import ContextMenu from '../contextMenu/contextMenuInit.vue';

import PaymentMethodMixins from './../../mixins/PaymentMethod.vue'
import InvoicesMixins from './../../mixins/Invoices.vue'
import SubscriptionsMixins from './../../mixins/Subscriptions.vue'

export default {
    name: 'billing-settings',

    components :{
        Checkbox,
        PaymentMethodPopup,
        BillingInformationPopup,
        ContextMenu
    },

    mixins: [PaymentMethodMixins,InvoicesMixins,SubscriptionsMixins],

    props : {
        infoUser : Object,
        infoAccount : Object,
        updateInfoAccount : Function,
        allPages : Array,
    },
    
    data() {
        return {
            popupOpen : null,
            invoices : [],
            invoiceSelect : [],

            //dowload multiple
            fileURLs : [],
            zip : null,
            count : 0,
        };
    },

    mounted() {

        this.listInvoices().then(res => {
            if(!res.data || !res.data.invoices || !res.data.invoices.length) 
                return

            this.invoices = res.data.invoices.filter(i => i.status != 'draft').map((invoice) => {
                return {
                    date : new Date((invoice.date || invoice.created) * 1000).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' }),
                    amount : (invoice.amount_due/100).toFixed(2),
                    plan : invoice.lines.data[0].plan ? invoice.lines.data[0].plan.nickname : '',
                    pdf : invoice.invoice_pdf,
                    number : invoice.number
                }
            })
        })
    },


    computed: {
       

        getMaxPages() {
            return this.infoUser._premium.plan ? Object.values(this.plans)[this.infoUser._premium.plan].nbrPages : this.plans['free'].nbrPages 
        },

        getMaxUsers() {
            return this.infoUser._premium.plan ? Object.values(this.plans)[this.infoUser._premium.plan].nbrUtilisateur : this.plans['free'].nbrUtilisateur 
        },

        getTextLocalisation() {
            let parts = [
                this.infoAccount.address,
                `${this.infoAccount.zipcode || ''} ${this.infoAccount.city || ''}`,
                this.infoAccount.country
            ];
          
            parts = parts.filter(part => part && part.trim() !== '').map(part => part.trim())
            
            if (parts.length > 0) { return parts.join(', ')}
            return 'Non definie'
        },

    
    },

    methods: {
        openPopUp(name) {
            this.popupOpen = name   
        },

        closePopUp() {
            this.popupOpen = null  
        },
        deletePaymentMethod() {

        },
        downloadInvoice(linkPdf) {
            this.downloadInvoices([linkPdf])
        },

        downloadAllInvoices(){
            this.downloadInvoices(this.invoices.map(invoice => invoice.pdf))
        },

        downloadInvoicesSelected(){
            this.downloadInvoices(this.invoices.filter(invoice => this.invoiceSelect.includes(invoice.number)).map(invoice => invoice.pdf))
        },

        async downloadInvoices(links) {
            let link = document.createElement("a");
            link.download = 'Invoice';
            //link.target = '_blank';

            for (let i = 0; i < links.length; i++) {
                const pdf = links[i];
                const newWindow = window.open('', 'Télechargement', '_blank');
                await new Promise(resolve => {
                    newWindow.document.body.appendChild(link);
                    link.href = pdf;
                    link.click();
                    newWindow.addEventListener('load', () => {
                        newWindow.close();
                        resolve()
                    });
                });    
            }
            link = null
        },

        addAllInvoice() {
            this.invoiceSelect = this.invoices.map(invoice => invoice.number);
        },
  
        removeAllInvoice() {
            this.invoiceSelect = []
        },

        addSelectInvoice(idInvoice) {
            if(!this.invoiceSelect.includes(idInvoice)) {
                this.invoiceSelect.push(idInvoice)
            }
        },

        removeSelectInvoice(idInvoice) {
            this.invoiceSelect = this.invoiceSelect.filter(number => number !== idInvoice)
        },

        //task a mettre dans une mixins
        copyViewerUrl(url) {
            const el = document.createElement('textarea');  
            el.value = url;                                 
            el.setAttribute('readonly', '');                
            el.style.position = 'absolute';                     
            el.style.left = '-9999px';                      
            document.body.appendChild(el);                  
            const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);                  
            if (selected) {                                 
                document.getSelection().removeAllRanges();    
                document.getSelection().addRange(selected);   
            }
        },

        clickOptionContextMenu(idContextMenu, nameOption) {
            switch (nameOption) {
                case 'copyLink': {
                    let invoice = this.invoices.find(invoice => invoice.number == idContextMenu)

                    if (invoice) {
                        this.copyViewerUrl(invoice.pdf)
                    }
                    break
                }
            }
        }
    },
};
</script>

